import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Cordyceps from './pages/Cordyceps';
import TurkeyTail from './pages/TurkeyTail';
import LionsMane from './pages/LionsMane';
import Reishi from './pages/Reishi';
import Chaga from './pages/Chaga';
import Shiitake from './pages/Shiitake';
import HowItWorks from './pages/HowItWorks';
import FAQ from './pages/FAQ';
import ThirdLiquidCulture from './pages/ThirdLiquidCulture';
export function App() {
  return <Router data-id="element-0">
      <div className="font-sans min-h-screen bg-white text-gray-900" data-id="element-1">
        <Navigation data-id="element-2" />
        <main data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/cordyceps" element={<Cordyceps data-id="element-8" />} data-id="element-7" />
            <Route path="/turkey-tail" element={<TurkeyTail data-id="element-10" />} data-id="element-9" />
            <Route path="/lions-mane" element={<LionsMane data-id="element-12" />} data-id="element-11" />
            <Route path="/reishi" element={<Reishi data-id="element-14" />} data-id="element-13" />
            <Route path="/chaga" element={<Chaga data-id="element-16" />} data-id="element-15" />
            <Route path="/shiitake" element={<Shiitake data-id="element-18" />} data-id="element-17" />
            <Route path="/how-it-works" element={<HowItWorks data-id="element-20" />} data-id="element-19" />
            <Route path="/faq" element={<FAQ data-id="element-22" />} data-id="element-21" />
            <Route path="/third-liquid-culture" element={<ThirdLiquidCulture data-id="element-24" />} data-id="element-23" />
          </Routes>
        </main>
      </div>
    </Router>;
}